var map = {
  "./": "6707",
  "./client": "2712",
  "./client.ts": "2712",
  "./dom/attr": "8959",
  "./dom/attr.ts": "8959",
  "./dom/beacon": "2863",
  "./dom/beacon.ts": "2863",
  "./dom/cookie": "1197",
  "./dom/cookie.ts": "1197",
  "./dom/css": "7339",
  "./dom/css.ts": "7339",
  "./dom/document": "1938",
  "./dom/document.ts": "1938",
  "./dom/element": "2439",
  "./dom/element.ts": "2439",
  "./dom/fontface": "6643",
  "./dom/fontface.ts": "6643",
  "./dom/fragments": "4046",
  "./dom/fragments.ts": "4046",
  "./dom/history": "461",
  "./dom/history.ts": "461",
  "./dom/open": "8805",
  "./dom/open.ts": "8805",
  "./dom/origin": "3261",
  "./dom/origin.ts": "3261",
  "./dom/performance": "4475",
  "./dom/performance.ts": "4475",
  "./dom/protocol": "6101",
  "./dom/protocol.ts": "6101",
  "./dom/serviceworker": "5707",
  "./dom/serviceworker.ts": "5707",
  "./dom/storage": "9227",
  "./dom/storage.ts": "9227",
  "./entry": "2534",
  "./entry.ts": "2534",
  "./events": "5008",
  "./events.ts": "5008",
  "./helpers": "7932",
  "./helpers.ts": "7932",
  "./index": "6707",
  "./index.ts": "6707",
  "./location": "8971",
  "./location.ts": "8971",
  "./shared/antiantidebugger": "8278",
  "./shared/antiantidebugger.ts": "8278",
  "./shared/blob": "9447",
  "./shared/blob.ts": "9447",
  "./shared/caches": "4169",
  "./shared/caches.ts": "4169",
  "./shared/chrome": "4522",
  "./shared/chrome.ts": "4522",
  "./shared/err": "5146",
  "./shared/err.ts": "5146",
  "./shared/error": "7651",
  "./shared/error.ts": "7651",
  "./shared/eval": "4423",
  "./shared/eval.ts": "4423",
  "./shared/event": "8231",
  "./shared/event.ts": "8231",
  "./shared/function": "7636",
  "./shared/function.ts": "7636",
  "./shared/import": "4636",
  "./shared/import.ts": "4636",
  "./shared/indexeddb": "2930",
  "./shared/indexeddb.ts": "2930",
  "./shared/opfs": "6970",
  "./shared/opfs.ts": "6970",
  "./shared/postmessage": "2625",
  "./shared/postmessage.ts": "2625",
  "./shared/realm": "6594",
  "./shared/realm.ts": "6594",
  "./shared/requests/eventsource": "2738",
  "./shared/requests/eventsource.ts": "2738",
  "./shared/requests/fetch": "106",
  "./shared/requests/fetch.ts": "106",
  "./shared/requests/websocket": "7219",
  "./shared/requests/websocket.ts": "7219",
  "./shared/requests/xmlhttprequest": "7481",
  "./shared/requests/xmlhttprequest.ts": "7481",
  "./shared/settimeout": "6775",
  "./shared/settimeout.ts": "6775",
  "./shared/sourcemaps": "6321",
  "./shared/sourcemaps.ts": "6321",
  "./shared/worker": "8475",
  "./shared/worker.ts": "8475",
  "./shared/wrap": "7706",
  "./shared/wrap.ts": "7706",
  "./singletonbox": "6890",
  "./singletonbox.ts": "6890",
  "./swruntime": "633",
  "./swruntime.ts": "633",
  "./worker/importScripts": "5425",
  "./worker/importScripts.ts": "5425"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5831;
